(function(){
'use strict';
function parseTime(value){
 if(typeof value!=='string')return NaN;
 value=value.replace(/([+-]\d{2})(\d{2})$/,'$1:$2');
 const m=/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|([+-])(\d{2}):(\d{2}))$/.exec(value);
 if(!m)return NaN;
 const y=+m[1],mo=+m[2],d=+m[3],h=+m[4],mi=+m[5],s=+m[6],oh=+(m[9]||0),om=+(m[10]||0);
 const date=new Date(Date.UTC(y,mo-1,d,h,mi,s));
 if(y<2000||date.getUTCFullYear()!==y||date.getUTCMonth()!==mo-1||date.getUTCDate()!==d||h>23||mi>59||s>59||oh>14||om>59||(oh===14&&om!==0))return NaN;
 return Date.parse(value);
}
function campaignState(enabled,start,end,now){
 const a=parseTime(start),b=parseTime(end);
 if(!enabled||!Number.isFinite(a)||!Number.isFinite(b)||a>=b)return 'ended';
 return now<a?'before':now<b?'active':'ended';
}
if(typeof module==='object'&&module.exports)module.exports={parseTime,campaignState};
if(typeof document==='undefined')return;
const el=document.getElementById('berke-campaign-config');if(!el)return;
let config;try{config=JSON.parse(el.textContent);}catch{return;}
const campaigns=Array.isArray(config.campaigns)?config.campaigns:[];
const params=new URL(location.href).searchParams;
const allowed=['auto','before','active','ended','ending'];
const demo=config.draft&&campaigns.some(c=>c.demo);
let mode=demo&&allowed.includes(params.get('promo_preview'))?params.get('promo_preview'):'auto';
let endedId=demo?params.get('promo_ended'):null;
let anchor=Date.now(),timer;
function timeFor(c){
 if(!config.draft||!c.demo||mode==='auto')return Date.now();
 const a=parseTime(c.start),b=parseTime(c.end);
 if(endedId===c.id||mode==='ended')return b;
 if(mode==='before')return a-1;
 if(mode==='active')return a+(b-a)/2;
 if(mode==='ending')return b-4000+(Date.now()-anchor);
 return Date.now();
}
function apply(){
 clearTimeout(timer);
 const states=new Map(),clocks=new Map();
 campaigns.forEach(c=>{
  const clock=timeFor(c);clocks.set(c.id,clock);
  const enabled=c.ready&&(c.enabled||(config.draft&&c.demo&&mode!=='auto'));
  states.set(c.id,campaignState(enabled,c.start,c.end,clock));
 });
 const active=Array.from(states.values()).some(s=>s==='active');
 document.querySelectorAll('[data-campaign-id]').forEach(n=>{n.hidden=states.get(n.dataset.campaignId)!=='active';});
 // Legacy primary-only price reference is not extended to other offers.
 document.querySelectorAll('[data-campaign-active]').forEach(n=>{n.hidden=states.get('bc_')!=='active';});
 // Keep the existing single top bar: first active campaign with countdown enabled.
 let topBarShown=false;
 document.querySelectorAll('.bare[data-campaign-id]').forEach(n=>{
  const show=!topBarShown&&states.get(n.dataset.campaignId)==='active';n.hidden=!show;if(show)topBarShown=true;
 });
 document.querySelectorAll('[data-campaign-neutral]').forEach(n=>{n.hidden=active;});
 document.querySelectorAll('[data-campaign-any]').forEach(n=>{n.hidden=!active;});
 document.querySelectorAll('[data-berke-preview]').forEach(n=>{n.dataset.currentState=active?'active':mode==='before'?'before':'ended';});
 document.querySelectorAll('[data-campaign-independent]').forEach(n=>{n.hidden=campaignState(true,n.dataset.start,n.dataset.end,Date.now())!=='active';});
 document.querySelectorAll('[data-campaign-list]').forEach(n=>{n.hidden=!Array.from(n.querySelectorAll('[data-campaign-id],[data-campaign-independent]')).some(x=>!x.hidden);});
 document.querySelectorAll('[data-campaign-countdown]').forEach(n=>{
  const id=n.dataset.campaignCountdown,c=campaigns.find(x=>x.id===id);if(!c)return;
  const seconds=Math.max(0,Math.ceil((parseTime(c.end)-clocks.get(id))/1000));
  const text=Math.floor(seconds/86400)+'d: '+Math.floor(seconds%86400/3600)+'h: '+Math.floor(seconds%3600/60)+'m: '+seconds%60+'s';
  if(n.textContent!==text)n.textContent=text;
 });
 document.querySelectorAll('[data-bc-mode]').forEach(n=>n.setAttribute('aria-pressed',String(n.dataset.bcMode===mode)));
 if(demo&&mode!=='auto')document.querySelectorAll('a[href]').forEach(a=>{
  const raw=a.getAttribute('href');if(!raw||raw.startsWith('#'))return;
  let url;try{url=new URL(a.href,location.href);}catch{return;}
  if(url.origin!==location.origin||/\/(cart|checkout|account)(\/|$)/.test(url.pathname))return;
  url.searchParams.set('preview_theme_id',config.themeId);url.searchParams.set('promo_preview',mode);
  if(endedId)url.searchParams.set('promo_ended',endedId);else url.searchParams.delete('promo_ended');
  if(a.href!==url.href)a.href=url.href;
 });
 timer=setTimeout(apply,1000);
}
if(demo){
 const bar=document.createElement('div');bar.dataset.bcTools='';bar.style.cssText='position:fixed;bottom:80px;left:8px;z-index:99999;background:white;color:#111;border:1px solid #999;padding:8px;max-width:calc(100vw - 32px);font:12px sans-serif';
 const label=document.createElement('strong');label.textContent='DEMO — kody testowe nie naliczają rabatów ';bar.append(label);
 [['before','Przed'],['active','Podczas'],['ended','Po'],['ending','Koniec za 4 s'],['auto','Daty']].forEach(([value,label])=>{
  const button=document.createElement('button');button.type='button';button.textContent=label;button.dataset.bcMode=value;button.style.cssText='margin:2px;padding:5px;border:1px solid #aaa;background:#f4f4f4;color:#111';
  button.addEventListener('click',()=>{mode=value;endedId=null;anchor=Date.now();const u=new URL(location.href);u.searchParams.set('promo_preview',mode);u.searchParams.delete('promo_ended');history.replaceState(null,'',u);apply();});bar.append(button);
 });
 const one=document.createElement('button');one.type='button';one.textContent='Zakończ tylko promocję 1';one.addEventListener('click',()=>{mode='active';endedId='bc_';const u=new URL(location.href);u.searchParams.set('promo_preview','active');u.searchParams.set('promo_ended','bc_');history.replaceState(null,'',u);apply();});bar.append(one);document.body.append(bar);
}
document.addEventListener('visibilitychange',()=>{if(!document.hidden)apply();});
window.addEventListener('pageshow',apply);document.addEventListener('shopify:section:load',apply);
new MutationObserver(records=>{if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&(n.matches('[data-campaign-id],[data-campaign-list],[data-berke-preview]')||n.querySelector('[data-campaign-id],[data-campaign-list],[data-berke-preview]')))))apply();}).observe(document.body,{childList:true,subtree:true});
apply();
})();
